import React, { useMemo } from "react";
import { observer, inject } from "mobx-react";
import "./VendorLogin.scss";
import VendorLoginStore from "./VendorLoginStore";
import Loader from "../../shared/Loader";

function VendorLogin({ store, completeVendorLogin }) {
  const vendorLoginStore = useMemo(() => {
    const vendorLoginStore = new VendorLoginStore({
      appStore: store,
      completeVendorLogin,
    });
    return vendorLoginStore;
  }, []);

  if (!store.authStore.vendorLoginRequired) return null;

  return (
    <div className="vendor-login widget">
      <div className="container">
        <h1>{vendorLoginStore.title}</h1>
        <p>{vendorLoginStore.message}</p>
        {vendorLoginStore.loading ? (
          <Loader />
        ) : (
          vendorLoginStore.type === "username_password" && (
            <form
              onSubmit={(e) => {
                e.preventDefault();
                vendorLoginStore.submit();
              }}
            >
              <input
                type="text"
                placeholder="username"
                value={vendorLoginStore.username}
                onChange={(e) => (vendorLoginStore.username = e.target.value)}
                autoComplete={`${vendorLoginStore.title} username`}
              />
              <input
                type="password"
                placeholder="password"
                value={vendorLoginStore.password}
                onChange={(e) => (vendorLoginStore.password = e.target.value)}
                autoComplete={`${vendorLoginStore.title} password`}
              />
              <div className="buttons">
                <input type="submit" className="primary btn" value="Login" />
                <button
                  className="secondary btn"
                  onClick={() => store.authStore.deauth()}
                >
                  Cancel
                </button>
              </div>
            </form>
          )
        )}
      </div>
    </div>
  );
}

export default inject("store")(observer(VendorLogin));
